import React from 'react';
import { func, object, string } from 'prop-types';
import ModalTemplate from '../ModalTemplate';
import { API_HOST } from '../../constants';
import './SocialInfoModal.scss';

const SOCIAL_INFO_MODAL_ID = 'socialInfoModal';

const SocialInfoModal = ({ onClose, userData, csrfToken }) => {
  const markAsShown = () => {
    fetch(`${API_HOST}/api/v2/user/mark_social_info_modal_shown`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken || ''
      },
      credentials: 'include'
    }).catch(() => {});
  };

  const handleDismiss = () => {
    markAsShown();
    onClose();
  };

  React.useEffect(() => {
    const modalOverlay = document.querySelector('.modal-conductor__overlay');
    if (modalOverlay) {
      modalOverlay.classList.add('social-info-modal-dark-overlay');
    }

    return () => {
      const overlay = document.querySelector('.modal-conductor__overlay');
      if (overlay) {
        overlay.classList.remove('social-info-modal-dark-overlay');
      }
    };
  }, []);

  return (
    <div className='social-info-modal-wrapper'>
      <button
        className='social-info-modal__mobile-close'
        onClick={handleDismiss}
        aria-label='Close'
      >
        <svg
          width='60'
          height='24'
          viewBox='0 0 60 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M15 8L30 16L45 8'
            stroke='currentColor'
            strokeWidth='3'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </button>
      <ModalTemplate
        modalTitle='Tell us a little about yourself'
        modalContent={
          <div className='social-info-modal__content'>
            <div className='social-info-modal__form-container'>
              <iframe
                src='https://lyodp-zgpl.maillist-manage.com/ua/Optin?od=11287ecd3bfee4&zx=13076733f&tD=115c4343b68effb91&sD=115c4343b6c2760d7'
                width='100%'
                height='100%'
                frameBorder='0'
                title='Zoho Survey'
              />
            </div>
          </div>
        }
        modalClose={handleDismiss}
        modalHideActions={true}
        modalHideCloseButton={false}
      />
    </div>
  );
};

SocialInfoModal.propTypes = {
  onClose: func.isRequired,
  userData: object,
  csrfToken: string
};

export default SocialInfoModal;
export { SOCIAL_INFO_MODAL_ID };
